import React, { Suspense, useEffect } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import ProjectLayout from "../ProjectLayout";
import ErrorBoundary from "../ErrrorBoundry";
import { getLocalStorageItem } from "../Utils";
import { useSelector } from "react-redux";
import { Skeleton } from "antd";

function ProtectedAuth() {
  const location = useLocation();
  const profileDetail = useSelector((state) => state.B2B.profileDetail);
  const navigate = useNavigate();
  const isAuthenticated = () => {
    const user = getLocalStorageItem("isLoggedIn");
    return user;
  };
  useEffect(() => {
    if (
      location.pathname !== "/kycStatus" &&
      location.pathname !== "/Report/wallet" &&
      location.pathname !== "/fundRequest" &&
      location.pathname !== "/dashboard" &&
      location.pathname !== "/lead-generation" &&
      location.pathname !== "/Report/lead-generation-report" &&
      location.pathname !== "/Report/user-report" &&
      location.pathname !== "/personal-info" &&
      location.pathname !== "/add-user" &&
      location.pathname !== "/Report/fund-request" &&
      ((!profileDetail?.role_type && profileDetail?.digio_kyc === "0") ||
        profileDetail.digio_kyc === "2" ||
        profileDetail.digio_kyc === "3")
    ) {
      navigate("/kycStatus");
    }
  }, [location]);

  return isAuthenticated() ? (
    <>
      {" "}
      <Suspense
        fallback={
          <div className="p-4">
            <Skeleton active className="mt-2" />
            <Skeleton active className="mt-2" />
            <Skeleton active className="mt-2" />
            <Skeleton active className="mt-2" />
            <Skeleton active className="mt-2" />
            <Skeleton active className="mt-2" />
          </div>
        }
      >
        <ProjectLayout>
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </ProjectLayout>
      </Suspense>
    </>
  ) : (
    <>
      <Navigate to="/" replace />
    </>
  );
}
export default ProtectedAuth;
